import React, { Component } from 'react';
import DemoComponent from './components/DemoComponent';

class App extends Component {
    render() {
        return (
            <div className="app">
                <DemoComponent />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js